import Vue from "vue";
import VxTooltip from "./layouts/components/vx-tooltip/VxTooltip.vue";
import VxCard from "./components/vx-card/VxCard.vue";
import VxList from "./components/vx-list/VxList.vue";
import VxBreadcrumb from "./layouts/components/VxBreadcrumb.vue";
import FeatherIcon from "./components/FeatherIcon.vue";
import VxInputGroup from "./components/vx-input-group/VxInputGroup.vue";
import ValidationPopup from "./components/ValidationPopup.vue";
import DeletePopup from "./components/DeletePopup.vue";
import PickFile from "./components/PickFile.vue";
import vSelect from "vue-select";
import Breadcrumb from "./components/common/Breadcrumb.vue";
import TermsAndConditions from "@/components/termCondition.vue";

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(VxBreadcrumb.name, VxBreadcrumb);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);
Vue.component(ValidationPopup.name, ValidationPopup);
Vue.component(DeletePopup.name, DeletePopup);
Vue.component(PickFile.name, PickFile);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(TermsAndConditions.name, TermsAndConditions);

vSelect.props.components.default = () => ({
  Deselect: {
    render: (createElement) =>
      createElement("feather-icon", {
        props: {
          icon: "XIcon",
          svgClasses: "w-4 h-4 mt-1",
        },
      }),
  },
  OpenIndicator: {
    render: (createElement) =>
      createElement("feather-icon", {
        props: {
          icon: "ChevronDownIcon",
          svgClasses: "w-5 h-5",
        },
      }),
  },
});

Vue.component(vSelect);
